/**
 * en-GB messages added by Phase 3 task W17 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w17EnGB = {
    // Live page
    'evac.page.title': 'Evacuation',
    'evac.page.description': 'Start an evacuation or a drill and follow the roll call as people are accounted for.',
    'evac.site': 'Site',
    'evac.noSite': 'Choose a site to see its evacuation.',
    'evac.remoteSite': 'Remote sites have no evacuations.',
    'evac.none.title': 'No evacuation is running at {site}.',
    'evac.none.body': 'Starting one builds the roll call from everyone signed in now and alerts the people set up to be told.',
    'evac.start.real': 'Start evacuation',
    'evac.start.drill': 'Start drill',
    'evac.start.realConfirm': 'Yes, start a real evacuation',
    'evac.start.drillConfirm': 'Yes, start a drill',
    'evac.start.noPermission': 'You do not have permission to start an evacuation.',
    'evac.start.already': 'An evacuation was already running here, so you are looking at that one.',
    'evac.end': 'End evacuation',
    'evac.end.confirm': 'Yes, end it',
    'evac.end.unaccounted': '{count} people are still unaccounted for. Ending closes the roll call.',
    'evac.ended.title': 'The evacuation has ended.',
    'evac.ended.body': 'The report is being prepared. You can open it from the evacuation reports.',
    'evac.ended.open': 'Open the report',
    'evac.banner.real': 'Evacuation in progress',
    'evac.banner.drill': 'Drill in progress',
    'evac.banner.detail': 'Started {time} by {by} ({source})',
    'evac.source.portal': 'the portal',
    'evac.source.kiosk': 'a kiosk',
    'evac.source.companion': 'the Companion app',
    'evac.source.fire_panel': 'the fire panel',
    'evac.source.system': 'the system',
    'evac.kind.real': 'Real',
    'evac.kind.drill': 'Drill',
    'evac.live.error': 'The roll call could not be loaded.',
    'evac.markFailed': 'That change was not saved. Check the roll call and try again.',
    'evac.checkDetail': 'Marks disagree',
    'evac.checkMark': '{status} by {by} at {time}',
    'evac.checkMarkPoint': '{status} at {point} by {by} at {time}',
    'evac.status.unaccounted': 'Unaccounted for',
    'evac.status.safe': 'Safe',
    'evac.status.missing': 'Missing',
    'evac.status.off_site': 'Off site',
    'evac.locations.title': 'Where people marked themselves safe',
    'evac.locations.description': 'Positions people shared with "I am safe", around the muster points.',
    'evac.locations.person': 'Safe: {name}',
    'evac.locations.centre': 'Muster points',
    // Site card
    'evac.card.title': 'Evacuation',
    'evac.card.description': 'Muster points, who may start an evacuation from a kiosk, marshals and who is emailed.',
    'evac.points.title': 'Muster points',
    'evac.points.empty': 'No muster points yet. Add where people should gather.',
    'evac.points.list': 'Muster points in order',
    'evac.points.add': 'Add a muster point',
    'evac.points.name': 'Name',
    'evac.points.directions': 'Directions',
    'evac.points.directionsHint': 'Shown to people on kiosks and in the app, for example "Car park B, by the bike shelter".',
    'evac.points.lat': 'Latitude',
    'evac.points.lng': 'Longitude',
    'evac.points.positionHint': 'Optional. Used to plot where people are in the report.',
    'evac.points.positionBoth': 'Give both latitude and longitude, or leave both empty.',
    'evac.points.positionRange': 'Latitude is between -90 and 90 and longitude between -180 and 180.',
    'evac.points.inactive': 'Not in use',
    'evac.points.active': 'In use',
    'evac.points.save': 'Save muster point',
    'evac.points.cancel': 'Cancel',
    'evac.points.edit': 'Edit {name}',
    'evac.points.deactivate': 'Stop using {name}',
    'evac.points.reactivate': 'Use {name} again',
    'evac.settings.defaultPoint': 'Default muster point',
    'evac.settings.defaultPointHint': 'Used for anyone without a point of their own.',
    'evac.settings.noDefault': 'None',
    'evac.settings.kioskStart': 'Starting from a kiosk',
    'evac.settings.kioskStart.off': 'Not allowed',
    'evac.settings.kioskStart.pin': 'Needs the evacuation PIN',
    'evac.settings.kioskStart.open': 'Anyone can start one',
    'evac.settings.kioskStartHint': 'Kiosks at this site show an Evacuate button when this is not "Not allowed".',
    'evac.pin.label': 'Evacuation PIN',
    'evac.pin.hint': '4 to 8 digits. It is stored scrambled and cannot be shown again.',
    'evac.pin.invalid': 'Use 4 to 8 digits.',
    'evac.pin.set': 'Set PIN',
    'evac.pin.clear': 'Remove PIN',
    'evac.pin.saved': 'PIN saved.',
    'evac.pin.cleared': 'PIN removed.',
    'evac.marshals.title': 'Marshals',
    'evac.marshals.hint': 'Marshals get the alerts and see the roll call in the Companion app (if their group allows it).',
    'evac.marshals.none': 'No marshals chosen.',
    'evac.marshals.list': 'Marshals',
    'evac.marshals.remove': 'Remove {name} as a marshal',
    'evac.marshals.group': 'Group',
    'evac.marshals.search': 'Find a member',
    'evac.marshals.add': 'Add {name} as a marshal',
    'evac.marshals.unknown': 'Unknown member',
    'evac.marshals.noGroups': 'There are no groups of regular members to choose from.',
    'evac.contacts.label': 'Contact emails',
    'evac.contacts.hint': 'Emailed when an evacuation starts and when its report is ready.',
    // Group card
    'evac.group.title': 'Evacuation',
    'evac.group.description': 'How this group appears on the roll call.',
    'evac.group.showOnList': 'Show this group on the evacuation list',
    'evac.group.showOnListHint': 'Turn off for groups who should not be counted, such as delivery drivers.',
    'evac.group.withHost': 'Visitors go to their host\'s muster point',
    'evac.group.withHostHint': 'Otherwise visitors use the points below.',
    'evac.group.defaultPoints': 'Default muster point at each site',
    'evac.group.noSites': 'There are no sites yet.',
    'evac.group.siteDefault': 'Use the site default',
    // Member override
    'evac.member.title': 'Muster point',
    'evac.member.description': 'Where this person gathers at each site. Leave it on the default unless they have a different point.',
    'evac.member.useDefault': 'Use the default',
    'evac.member.forSite': 'Muster point at {site}',
    'evac.member.saved': 'Muster point saved.',
    'evac.member.noPoints': 'No muster points set up yet.',
    'evac.member.noSites': 'There are no sites yet.',
    // Reports
    'evac.reports.title': 'Evacuation reports',
    'evac.reports.description': 'Every evacuation and drill, with who was accounted for and when.',
    'evac.reports.kind': 'Type',
    'evac.reports.real': 'Real evacuations',
    'evac.reports.drills': 'Drills',
    'evac.reports.allSites': 'All sites',
    'evac.reports.dates': 'Started between',
    'evac.reports.table': 'Evacuations',
    'evac.reports.col.started': 'Started',
    'evac.reports.col.site': 'Site',
    'evac.reports.col.duration': 'Duration',
    'evac.reports.col.safe': 'Safe',
    'evac.reports.col.outstanding': 'Not accounted for',
    'evac.reports.col.report': 'Report',
    'evac.reports.running': 'Running',
    'evac.reports.ended': 'Ended',
    'evac.reports.updated': 'Updated after it ended',
    'evac.reports.preparing': 'Being prepared',
    'evac.reports.ready': 'Ready',
    'evac.reports.open': 'Open',
    'evac.reports.openFor': 'Open the report for {site}, {time}',
    'evac.detail.back': 'All evacuation reports',
    'evac.detail.title': '{kind} at {site}',
    'evac.detail.summary': 'Summary',
    'evac.detail.duration': 'Duration',
    'evac.detail.allAccounted': 'Time to account for everyone',
    'evac.detail.neverAccounted': 'Not everyone was accounted for',
    'evac.detail.total': 'On the roll call',
    'evac.detail.safe': 'Safe',
    'evac.detail.missing': 'Missing',
    'evac.detail.offSite': 'Off site',
    'evac.detail.unaccounted': 'Unaccounted for',
    'evac.detail.byPoint': 'Safe at each muster point',
    'evac.detail.byPointNone': 'No one was marked safe at a muster point.',
    'evac.detail.noPoint': 'No muster point',
    'evac.detail.missingList': 'People not accounted for',
    'evac.detail.missingNone': 'Everyone was accounted for.',
    'evac.detail.timeline': 'Timeline',
    'evac.detail.timelineNone': 'No marks were made.',
    'evac.detail.col.time': 'Time',
    'evac.detail.col.person': 'Person',
    'evac.detail.col.status': 'Status',
    'evac.detail.col.by': 'Marked by',
    'evac.detail.col.group': 'Group',
    'evac.detail.col.host': 'Host',
    'evac.detail.notApplied': 'Not used (a later mark decided)',
    'evac.detail.pdf': 'Download PDF',
    'evac.detail.pdfFailed': 'The PDF is not ready yet. Try again in a minute.',
    'evac.detail.updatedNote': 'This report was rebuilt after late marks were added.',
    'evac.detail.delete': 'Delete this evacuation',
    'evac.detail.deleteHint': 'Deleting removes the roll call, every mark and the PDF for good.',
    'evac.detail.stillActive': 'This evacuation is still running.',
    'evac.detail.openLive': 'Open the live roll call',
    'evac.detail.rollCall': 'Roll call',
    'evac.mark.marshal': 'a marshal',
    'evac.mark.portal': 'the portal',
    'evac.mark.kiosk': 'a kiosk',
    'evac.mark.self_app': 'the person (app)',
    'evac.mark.self_contactless': 'the person (their phone)',
    'evac.mark.fire_panel': 'the fire panel',
    'evac.minutes': '{m} min',
    'evac.minutesSeconds': '{m} min {s} s',
    'evac.seconds': '{s} s',
    // Fire panels
    'evac.panels.title': 'Fire panels',
    'evac.panels.description': 'Let a fire alarm panel start and end an evacuation by itself.',
    'evac.panels.new': 'New fire panel',
    'evac.panels.table': 'Fire panels',
    'evac.panels.empty': 'No fire panels are connected.',
    'evac.panels.col.name': 'Name',
    'evac.panels.col.site': 'Site',
    'evac.panels.col.mode': 'Security',
    'evac.panels.col.lastCall': 'Last call',
    'evac.panels.col.status': 'Status',
    'evac.panels.col.actions': 'Actions',
    'evac.panels.mode.signed': 'Signed requests',
    'evac.panels.mode.token': 'Secret token and address list',
    'evac.panels.modeHint': 'Signed requests are safest. Use a token only for panels that cannot sign.',
    'evac.panels.never': 'Never called',
    'evac.panels.enabled': 'Enabled',
    'evac.panels.disabled': 'Disabled',
    'evac.panels.name': 'Name',
    'evac.panels.site': 'Site',
    'evac.panels.cidrs': 'Allowed addresses',
    'evac.panels.cidrsHint': 'One address or range per line, for example 203.0.113.7 or 203.0.113.0/24. Needed for token mode.',
    'evac.panels.cidrsNeeded': 'Token mode needs at least one address.',
    'evac.panels.canEndAny': 'This panel may end any evacuation at the site',
    'evac.panels.canEndAnyHint': 'Otherwise it can only end one it started.',
    'evac.panels.create': 'Create fire panel',
    'evac.panels.url': 'Address to call',
    'evac.panels.rotate': 'Replace secret',
    'evac.panels.rotateFor': 'Replace the secret for {name}',
    'evac.panels.rotateConfirm': 'Yes, replace it',
    'evac.panels.disable': 'Disable',
    'evac.panels.enable': 'Enable',
    'evac.panels.edit': 'Edit',
    'evac.panels.save': 'Save changes',
    'evac.panels.delete': 'Delete',
    'evac.panels.deleteConfirm': 'Yes, delete it',
    'evac.panels.secretTitle': 'Secret for {name}',
    'evac.panels.secretDescription': 'Give this to whoever sets up the panel. It is shown once and cannot be found again; use "Replace secret" if it is lost.',
    'evac.panels.secretLabel': 'Secret',
    'evac.panels.testNote': 'To check a panel is connected, send a "test" call. It is logged and changes nothing.',
    'evac.panels.lastResult': 'Last result: {result}',
};
//# sourceMappingURL=w17.js.map